import { useField } from '~/hooks';
import React from 'react';
import styled from 'styled-components';
import { getColorHex } from '~/components/taskTypeColors';
import FieldControl from '~/components/FieldControl';
import Icon from '~/components/Icon';
import SingleSelect from '~/components/SingleSelect';

const iconOptions = [
  { id: 'check-circle', name: 'Check Circle', value: 'check-circle' },
  { id: 'folder', name: 'Folder', value: 'folder' },
  { id: 'tasks', name: 'Tasks', value: 'tasks' },
  { id: 'clipboard', name: 'Clipboard', value: 'clipboard' },
  { id: 'star', name: 'Star', value: 'star' },
  { id: 'tag', name: 'Tag', value: 'tag' },
  { id: 'lightbulb', name: 'Lightbulb', value: 'lightbulb' },
  { id: 'rocket', name: 'Rocket', value: 'rocket' },
  { id: 'cog', name: 'Cog', value: 'cog' },
  { id: 'wrench', name: 'Wrench', value: 'wrench' },
  { id: 'file', name: 'File', value: 'file' },
  { id: 'file-alt', name: 'Document', value: 'file-alt' },
  { id: 'calendar', name: 'Calendar', value: 'calendar' },
  { id: 'clock', name: 'Clock', value: 'clock' },
  { id: 'user', name: 'User', value: 'user' },
  { id: 'users', name: 'Users', value: 'users' },
];

const IconOption = styled.span`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  margin-right: 0.5rem;
  flex-shrink: 0;
`;

function FieldIconSelect({ placeholder = 'Icon', color, ...props }) {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const colorHex = getColorHex(color);

  const renderValue = (value) => {
    const icon = iconOptions.find((i) => i.value === value);
    if (!icon) return null;
    return (
      <IconOption>
        <IconWrapper>
          <Icon icon={icon.value} color={colorHex} />
        </IconWrapper>
        {icon.name}
      </IconOption>
    );
  };

  return (
    <FieldControl error={error}>
      <SingleSelect {...field} {...props} placeholder={placeholder} valueRenderer={renderValue}>
        {iconOptions.map((icon) => (
          <option key={icon.id} value={icon.value}>
            <IconOption>
              <IconWrapper>
                <Icon icon={icon.value} color={colorHex} />
              </IconWrapper>
              {icon.name}
            </IconOption>
          </option>
        ))}
      </SingleSelect>
    </FieldControl>
  );
}

export default FieldIconSelect;
